import Crud from '../views/Finalizacao_Receita/Crud'
import Entity from '../views/Finalizacao_Receita/Add'

let routes = {
    path: '/finalizacao_receitas',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/finalizacao_receitas/add',
            name: 'NewFinalizacaoReceita',
            component: Entity,
            meta: {
                pageTitle: 'Adicionar Finalização Receita',
                breadcrumb: [
                    {
                        text: 'Finalização Receitas',
                        to: '/finalizacao_receitas',
                        active: false,
                    },
                    {
                        text: 'Criar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/finalizacao_receitas/edit/:id?',
            name: 'EditFinalizacaoReceita',
            component: Entity,
            meta: {
                pageTitle: 'Editar Finalização Receita',
                breadcrumb: [
                    {
                        text: 'Finalização Receitas',
                        to: '/finalizacao_receitas',
                        active: false,
                    },
                    {
                        text: 'Editar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/finalizacao_receitas',
            name: 'list-finalizacao_receitas',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Finalização de Receitas',
                breadcrumb: [
                    {
                        text: 'Finalização Receitas',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
